import React, { useState } from "react";
import * as Utils  from "../../helpers/Utils";

import "../../../../assets/stylesheets/login/login.scss";

function ResetPassword(props) {

  const { actions, loginData } = props;
  const { validationError } = props.loginData;

  function setInputState(name, value) {
    const data = {
      name,
      value,
    };
    actions.loginActions.removeInputError(name);
    actions.loginActions.updateLoginInfo(data);
  }

  function closeRegisterPanel() {
    actions.registerActions.hideRegisterPanel(false);
  }

  function showLoginPage() {
    actions.registerActions.showLoginPage();
  }

  function handleInputChange(event) {
    setInputState(event.target.name, event.target.value);
  }

  function forgotPasswordCTA() {
    const errors = Utils.validateResetPwdForm(loginData);
    if (errors.length) {
      actions.loginActions.updateValidationError(errors);
    }
    else {
      let dataToPost = {
        "link_code": Utils.getParameterByName("link_code"),
        "password": loginData.password,
        "password_confirmation": loginData.confirm_password
      }
      actions.loginActions.tryResetPassword(dataToPost);
    }
  }

  return (
    <div className="login-ui-container">
      <div className="cross-container cp" onClick={e => closeRegisterPanel()}>
        <img height="30px" src="https://d3brnpc5nhvc9v.cloudfront.net/site/static-images/Close-Button.png" alt="Group-20133" border="0" />
      </div>
      <div className="register-field-container">
        <p className="gp-text24 gp-mb20">
          Set New Password
        </p>
        <p className="gp-text16 gp-636363 gp-lh162  gp-mb20">
          Enter your password and reset password
        </p>
        {!loginData.resetFlowComplete && <div>
          <div className={"floating-label input-group "}>
            <input
              name="password"
              type="text"
              placeholder="Enter your password"
              className={`common-input floating-input ${validationError.includes('password') ? "error-input" : "correct-input"}`}
              onChange={handleInputChange}
              autoComplete="false"
            />
          </div>

          <div className={"floating-label input-group "}>
            <input
              name="confirm_password"
              type="text"
              placeholder="Confirm your password"
              className={`common-input floating-input ${validationError.includes('confirm_password') ? "error-input" : "correct-input"}`}
              onChange={handleInputChange}
              autoComplete="false"
            />
          </div>
        </div>}
        {loginData.resetAttemptFailed && (
          <div className="checkbox-error tc gp-mt20 gp-mb20">
            <span className="error-text gp-text14 gp-FE696E">
              Reset Attempt Failed.Please check credentials and try again
            </span>
          </div>
        )}
        {loginData.resetFlowComplete && (
          <div className="checkbox-error tc gp-mt20 gp-mb20">
            <span className="gp-text14 gp-1E8EA5">
              Password reset Successfull
            </span>
          </div>
        )}
        {!loginData.resetFlowComplete && <div className="signup-container cp" onClick={() => forgotPasswordCTA()}>
          Update Password
        </div>}
        <div className="sigin-link gp-mt20 tc gp-text16 gp-f400 gp-lh19" onClick={showLoginPage}>
          <span>Back to </span> <span className="gp-1E8EA5 cp">login</span>
        </div>
        <div className="copyright-container gp-text12 gp-636363">
          Impressum © 2021 GoParts GmbH  |  Privacy Terms & Conditions
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
